import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { initPreferences } from './lib/preferences';
import { App } from './app/App';
import { registerServiceWorker } from './features/platform/offline/registerServiceWorker';

// Apply text size / theme / contrast before the first paint (R-5.7).
initPreferences();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// ---------------------------------------------------------------------------------------------------------
// SERVICE WORKER HOOK POINT — OWNER: platform module (PWA / offline queue, NFR "Offline").
// The foundation deliberately ships no service worker. Register it here, e.g.:
//   if ('serviceWorker' in navigator && import.meta.env.PROD) {
//     window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
//   }
// ---------------------------------------------------------------------------------------------------------
registerServiceWorker();
